<template>
  <div class="normal-user-relation">
    <p class="btn-base btn-letter" @click="sendLetter">私信</p>
    <p
      class="btn-base"
      :class="[hasFollow ? 'btn-has-follow' : 'btn-follow']"
      @click="toggleFollow"
    >
      <template v-if="hasFollow">
        <span>已关注</span>
      </template>
      <template v-else>
        <img src="~images/platform/homepage/nm-follow-add-btn.png" alt="" />
        <span>关注</span>
      </template>
    </p>
  </div>
</template>
<script>
export default {
  computed: {
    userRelation() {
      return this.$store.state.homepage.userRelation
    },
    // 是否已关注
    hasFollow() {
      return this.userRelation && +this.userRelation.follow === 1
    }
  },
  methods: {
    sendLetter() {
      this.$emit('letter')
    },
    toggleFollow() {
      this.$emit('follow')
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~lib/scss/functions.scss';
@import '~style/platform/homepage/userinfo.scss';

.normal-user-relation {
  margin-left: auto;
  display: flex;
  align-items: center;
  .btn-letter {
    color: #6982fa;
    border-radius: 27px;
    border: 2px solid #6982fa;
  }
}
</style>
